export default __webpack_public_path__ + "static/automobile-slider-956f26424dee30da7b8b75884d8b247c.gif";